import React from 'react';
import './ImagePreview.css';

interface ImagePreviewProps {
  visible: boolean;
  onClose: () => void;
  imagePath: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({ visible, onClose, imagePath }) => {
  if (!visible) return null;

  return (
    <div className="image-preview-overlay" onClick={onClose}>
      <div className="image-preview-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-preview-close" onClick={onClose}>
          ×
        </button>
        <img 
          src={imagePath} 
          alt="预览图片" 
          className="image-preview-image"
          onError={(e) => {
            console.error('图片预览加载失败:', imagePath);
            e.currentTarget.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
}; 